import React from 'react';
import { SectionHeading } from './SectionHeading';
import { brandName, firstTimeSteps, systemFlow } from '../data/copy';

/** Reassurance for first-time coaches: the five things the system answers, in coaching order. */
export function FirstTimeSection() {
  return <section className="w-full bg-slate-950 py-10 [contain-intrinsic-size:auto_900px] [content-visibility:auto] sm:py-14 [.chalk_&]:bg-slate-50" aria-labelledby="first-time-heading" data-id="element-93" data-mp="310k7issviylt">
      <div className="mx-auto max-w-4xl px-6" data-id="element-94" data-mp="39xm72plb1oh4">
        <SectionHeading eyebrow="Coaching for the first time?" title={<span id="first-time-heading" data-id="element-96" data-mp="35zwvjgvhebpz">You do not need to know everything.</span>} lead="You only need to know five things:" data-id="element-95" data-mp="35ydc5hej3kjz" />

        <ol className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-px overflow-hidden rounded-3xl border border-slate-800 bg-slate-800 sm:grid-cols-5 [.chalk_&]:border-slate-200 [.chalk_&]:bg-slate-200" data-id="element-97" data-mp="3eys06oivndr6">
          {firstTimeSteps.map((step, index) => <li key={step} className="flex items-center gap-4 bg-slate-900 px-5 py-4 sm:flex-col sm:items-start sm:gap-3 sm:px-4 sm:py-5 [.chalk_&]:bg-white" data-id="element-98" data-mp="1km23y051dsgm" data-mpi={index}>
              <span className="text-3xl font-extrabold leading-none tracking-tight text-orange-400 [.chalk_&]:text-orange-600" data-id="element-99" data-mp="26m37z9uzt7q6">
                {index + 1}
              </span>
              <span className="text-base font-bold uppercase leading-tight tracking-tight text-slate-50 [.chalk_&]:text-slate-900" data-id="element-100" data-mp="2amdfws2ci87o">
                {step}
              </span>
            </li>)}
        </ol>

        <div className="mt-8 text-center" data-id="element-101" data-mp="2pd431mszsj4g">
          <p className="text-lg text-slate-400 [.chalk_&]:text-slate-600" data-id="element-102" data-mp="2pbt1ltn0rngi">
            That is exactly how <span className="font-semibold text-slate-50 [.chalk_&]:text-slate-900" data-id="element-103" data-mp="2ud8olr8rc41j">{brandName}</span> is designed.
          </p>
          <p className="mt-3 text-xl font-extrabold uppercase tracking-tight text-orange-400 sm:text-2xl [.chalk_&]:text-orange-600" data-id="element-104" data-mp="2yczja61en4bc">
            {systemFlow}
          </p>
        </div>
      </div>
    </section>;
}